export default "__VITE_ASSET__BY_654Vi__"